import React from 'react'

import {
  DriftOrderItem,
  GiftCardOrderItem,
  GiftSubscriptionBanner,
  GiftSubscriptionOfferOrderItem,
  GiftSubscriptionOrderItem,
  LimitedDropOrderItem,
  ProductOrderItem,
  SubscriptionBanner,
  SubscriptionOrderItem,
} from 'compositions/orderItems'

import useCartItems from './util/useCartItems'


type CartItemsProps = {
  className?: string
  cart: CartModule.Cart
}

const CartItems: React.FunctionComponent<CartItemsProps> = (props) => {
  const { className, cart } = props

  const {
    orderItems: { giftCard, giftSubscription, giftSubscriptionOffer, limitedDrops, products, subscription },
    subscriptionBanner,
    giftSubscriptionBanner,
    hasAcademyCourse,
  } = useCartItems(cart)

  let hasFirstItem = false
  const getClassName = (): string => {
    if (hasFirstItem) {
      return 'mt-16'
    }

    hasFirstItem = true
    return null
  }

  return (
    <div className={className}>
      {
        Boolean(subscription) && (
          <SubscriptionOrderItem
            className={getClassName()}
            data={subscription}
            giftSubscriptionOffer={giftSubscriptionOffer}
            withRemoveButton
          />
        )
      }
      {
        Boolean(giftSubscription) && (
          <GiftSubscriptionOrderItem
            className={getClassName()}
            data={giftSubscription}
            withRemoveButton
          />
        )
      }
      {
        Boolean(giftCard) && (
          <GiftCardOrderItem
            className={getClassName()}
            data={giftCard}
            withRemoveButton
          />
        )
      }
      {
        Boolean(giftSubscriptionOffer) && (
          <GiftSubscriptionOfferOrderItem
            className={getClassName()}
            data={giftSubscriptionOffer}
          />
        )
      }
      {
        limitedDrops?.map((item) => {
          const { uid } = item

          return (
            <LimitedDropOrderItem
              key={uid}
              className={getClassName()}
              data={item}
              placement="cart"
            />
          )
        })
      }
      {
        products?.map((item) => {
          const { uid, drift, isRemovable, size } = item

          const key = `${uid}-${size}-${drift?.starterSet}`

          const props = {
            className: getClassName(),
            data: item,
            withRemoveButton: isRemovable,
          }

          if (drift) {
            return (
              <DriftOrderItem key={key} {...props} />
            )
          }

          return (
            <ProductOrderItem key={key} {...props} />
          )
        })
      }
      {
        Boolean(subscriptionBanner) && (
          <SubscriptionBanner
            className={getClassName()}
            onCancel={subscriptionBanner.onCancel}
            hasAcademyCourse={hasAcademyCourse}
          />
        )
      }
      {
        Boolean(giftSubscriptionBanner) && (
          <GiftSubscriptionBanner
            className={getClassName()}
            data={giftSubscriptionOffer}
            onCancel={giftSubscriptionBanner.onCancel}
          />
        )
      }
    </div>
  )
}


export default CartItems
